import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
// import Particle2 from "../Particle2";

import noBroker from "../../Assets/Projects/Nobroker.png"
import Quora from "../../Assets/Projects/quora.png"
import Redbus from "../../Assets/Projects/redbus.png"
import CricInfo from "../../Assets/Projects/cricInfo.png"
import Flipkart from "../../Assets/Projects/flipkart.png"
import Meesho from "../../Assets/Projects/Meesho.png"
import BlogApp from "../../Assets/Projects/blogapp.png";
// import spotify from "../../Assets/Projects/Spotify.png";
// import indiaToday from "../../Assets/Projects/indiaToday.png";
// import meanBuy from "../../Assets/Projects/meanBuy.png";
// import countryDetails from "../../Assets/Projects/countryDetails.png";
// import fitnessClub from "../../Assets/Projects/fitnessClub.png";
// import weatherForecast from "../../Assets/Projects/weatherForecast.png";
// import ticTacToe from "../../Assets/Projects/ticTacToe.png";

function Projects() {
  return (
    <div className="project-background activeNavlink" id="scrollProjects">
      {/* <Particle2 /> */}
      <Container fluid className="project-section">
        <Container>
          <h1 className="project-heading">
            My Recent <strong className="purple">Projects </strong>
          </h1>
          <p style={{ color: "white" }}>
            Here are a few projects I've worked on recently.
          </p>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>


            <Col md={6} className="project-card">
              <ProjectCard
                imgPath={BlogApp}
                isBlog={false}
                title="Blog App"
                tool=" Jwt-Auth, Mongoose, Nodejs, React, express, MongoDb, Bcryptjs  JavaScript, HTML, CSS,"
                description="It's a full stack blog web application in which user can read the published blogs and user need to authenticate (with JWT token) then can have access of dashboard for CRUD on blogs. User can signin, signup, signout in account. Also can edit and see his/her profile details. By clicking on any blog card can see blog details."
                link="https://github.com/Akashjadhav55/Blog_MERN_APP"
                demoLink="https://blogapplications.netlify.app/"
              />
            </Col>
            
            <Col md={6} className="project-card">
              <ProjectCard
                imgPath={Flipkart}
                isBlog={false}
                title="Flipkart"
                tool="REACT , REDUX , CHAKRA UI , STYLED-COMPONENTS , REACT-ROUTER , DOM , Local Storage , JSON Server , Node.js , Express , MongoDB"
                description="The One-stop Shopping Destination. E-commerce is revolutionizing the way we all shop in India."
                link="https://github.com/mr-ramzan01/filpkart-clone-backend"
                demoLink="https://flipkart-clone-project-m.netlify.app/"
              />
            </Col>

            <Col md={6} className="project-card">
              <ProjectCard
                imgPath={CricInfo}
                isBlog={false}
                title="ESPN cricinfo"
                tool="REACT , REDUX , CHAKRA UI , STYLED-COMPONENTS , REACT-ROUTER , DOM , Local Storage , JSON Server , Node.js , Express , MongoDB"
                description="ESPN Cricinfo-Clone (React Application) --> Web application which provide information about cricket scores, teams, players, cricket news, news videos about cricket and user can create a teams to participate in contests ."
                link="https://github.com/akram3598786/ESPNcricinfo_Clone_MERN"
                demoLink="https://cricinfoclone.netlify.app/"
              />
            </Col>

            {/* Co-Schedule Clone -------------------------------------------------------------------*/}
            {/* <Col md={6} className="project-card">
              <ProjectCard
                imgPath={noBroker}
                isBlog={false}
                title="Nobroker"
                tool="  JavaScript, HTNL, CSS, React, Redux, Nodejs, MongoDB, Express, ChakraUi, Local Storage"
                description="NoBroker is a disruptive real-estate platform that makes it possible to buy/sell/rent a house without paying any brokerage NoBroker was started because all of us believed that paying hefty brokerage can not be the only option to find a new home. As tenants, we have been paying these brokerages year on year without seeing any…"
                link="https://github.com/SaurabhSinghRbz/no-broker-clone"
                demoLink="https://nobrokerclone.netlify.app/buy"
              />
            </Col> */}

            {/* Spotify 2.0 ------------------------------------------------------------- */}
            <Col md={6} className="project-card">
              <ProjectCard
                imgPath={Redbus}
                isBlog={false}
                title="Redbus"
                tool="  JavaScript, HTML, CSS, Json-server"
                description="Red-Bus is India's largest online bus ticketing platform that has transformed bus travel in the country by bringing ease and convenience to millions of Indians who travel using buses. Founded in 2006, redBus is part of India's leading online travel company MakeMyTrip Limited."
                link="https://github.com/vishalvsk/Red-Bus-Clone"
                demoLink="https://clone-redbus.netlify.app/"
              />
            </Col>


            <Col md={6} className="project-card">
              <ProjectCard
                imgPath={Meesho}
                isBlog={false}
                title="Meesho"
                tool="  JavaScript, HTML, CSS, React, Redux, ChakraUi, Local Storage"
                description="This is Solo Project Meesho-Clone.Indian No.1 eCommerce Website.Meesho is a social commerce platform that undertakes retail distribution, enabling small retail merchants to connect and sell their products effectively via social media channels."
                link="https://github.com/Akashjadhav55/Meesho"
                demoLink="https://meesho-clone-app.netlify.app/"
              />
            </Col>

            {/* Fitness Club ------------------------------------------------------------- */}
            <Col md={6} className="project-card">
              <ProjectCard
                imgPath={Quora}
                isBlog={false}
                title="Quora"
                tool=" JavaScript, HTML, CSS, Json-server"
                description="Quora is a place to gain and share knowledge. It's a platform to ask questions and connect with people who contribute unique insights and quality answers.platform that empowers people to share and grow the world's knowledge. People come to Quora to ask questions about any subject."
                link="https://github.com/Akashjadhav55/Quora_Clone"
                demoLink="https://qoura-clone.netlify.app/"
              />
            </Col>



            {/* India Today Clone ---------------------------------------------------------------- */}
            

            {/* MeanBuy Clone ---------------------------------------------------------------------- */}
            {/* <Col md={6} className="project-card second-blog">
              <ProjectCard
                imgPath={meanBuy}
                isBlog={false}
                title="MeanBUy"
                tool="JavaScript, HTML, CSS, DOM-Manipulation, Localstorage "
                description="This website is a clone of MeanBuy.com .MeanBuy is the future of online shopping. we let our customers Pay What They Want to Pay on a variety of retail products, ranging from women’s accessories to consumer electronics on MeanBuy.com."
                link="https://github.com/SaurabhSinghRbz/project_MeanBuy"
                demoLink="https://saurabhsinghrbz.github.io/project_MeanBuy/"
              />
            </Col> */}


          </Row>
        </Container>


        <Container>
          {/* <h1 className="project-heading">
            Mini <strong className="purple">Projects </strong>
          </h1> */}
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

            {/* Tic-tac-toe-------------------------------------------------------------------------- */}
            {/* <Col md={6} className="project-card second-blog">
              <ProjectCard
                imgPath={ticTacToe}
                isBlog={false}
                title="Tic-Tac-Toe"
                tool="JavaScript, HTML, CSS, React, React-Hooks, react-router-dom"
                description="Tic-tac-toe, noughts and crosses, or Xs and Os is a paper-and-pencil game for two players who take turns marking the spaces in a three-by-three grid with X or O. The player who succeeds in placing three of their marks in a horizontal, vertical, or diagonal row is the winner. It is a solved game, with a forced draw assuming best play from both players."
                link="https://github.com/SaurabhSinghRbz/tic-tac-toe"
                demoLink="https://tic-tac-toe2-0.netlify.app/"
              />
            </Col>
 */}


            {/* Weather Forecast-------------------------------------------------------------------------- */}
            {/* <Col md={6} className="project-card second-blog">
              <ProjectCard
                imgPath={weatherForecast}
                isBlog={false}
                title="Weather Forecast"
                tool="JavaScript, HTML, CSS, DOM-Manipulation, Rest API"
                description="This is my first webpage, which I made after my first class on Rest-API. Weather forecasting is the application of science and technology to predict the conditions of the atmosphere for a given location and time. People have attempted to predict the weather informally for millennia and formally since the 19th century."
                link="https://github.com/SaurabhSinghRbz/weatherForecast"
                demoLink="https://current-weather.vercel.app/"
              />
            </Col> */}


            {/* Country Details -------------------------------------------------------- */}
            {/* <Col md={6} className="project-card second-blog">
              <ProjectCard
                imgPath={countryDetails}
                isBlog={false}
                title="All Country Details"
                tool="JavaScript, HTML, CSS, DOM-Manipulation "
                description="This is my first webpage, which i made after my first two class of HTML and CSS. This webpage contains all sorts of useful information about every country packaged as convenient little country objects. It includes data from ISO 3166 (countries and states/subdivisions ), ISO 4217 (currency), and E.164 (phone numbers)."
                link="https://github.com/SaurabhSinghRbz/All_Country_Details"
                demoLink="https://allcountry-details.netlify.app/"
              />
            </Col> */}


          </Row>
        </Container> 
      </Container>

    </div>
  );
}

export default Projects;
